// Remembers how a visitor arrived (referral code, "Powered by" link, listing claim, campaign)
// until they register, so wandering around the site first does not lose it.

const KEY = 'signup_attribution';
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
const FIELDS = {
  ref: 'referral_code',
  via: 'referred_via',
  claim: 'claim_listing_id',
  utm_source: 'utm_source',
};
const LIMITS = { referral_code: 20, referred_via: 80, claim_listing_id: 80, utm_source: 40 };

function clean(field, value) {
  const text = String(value || '').trim().slice(0, LIMITS[field]);
  return /^[A-Za-z0-9_.-]+$/.test(text) ? text : '';
}

export function getAttribution() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!saved || Date.now() - (saved.at || 0) > MAX_AGE_MS) return {};
    const { at, ...rest } = saved;
    return rest;
  } catch {
    return {};
  }
}

/** Store whatever attribution the URL carries, keeping earlier values the URL does not override. */
export function captureAttribution(searchParams) {
  const found = {};
  Object.entries(FIELDS).forEach(([param, field]) => {
    const value = clean(field, searchParams.get(param));
    if (value) found[field] = value;
  });
  if (!Object.keys(found).length) return getAttribution();
  const merged = { ...getAttribution(), ...found };
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...merged, at: Date.now() }));
  } catch { /* storage blocked: the values still go with this page's signup */ }
  return merged;
}

export function clearAttribution() {
  try { localStorage.removeItem(KEY); } catch { /* storage blocked */ }
}
